import React, {useState, useEffect} from 'react';
import { Table, Tag, Col, Row } from 'antd';
import AppointmentFilters from './AppointmentFilters';
import { customerAppointment } from '../../../services/serviceReports';
import { CalendarTwoTone } from '@ant-design/icons';
import AppointmentDetails from '../../appointment/AppointmentDetails';
import AppointmentChart from './AppointmentChart';

const AppointmentList = ({customer, baseDates}) => {
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        getCustomerAppointments();
    }, [customer, baseDates])
  
    const getCustomerAppointments = (appointmentStatus, dateRanges) => {
        let sDate = dateRanges?.length ? dateRanges[0] : baseDates[0];
        let eDate = dateRanges?.length ? dateRanges[1] : baseDates[1];

        const requestObj = {
            customerId: customer,
            appointmentStatus,
            startDate: sDate,
            endDate: eDate
        };

        customerAppointment(requestObj)
            .then(({data}) => {
                if(data) {
                    setTableData(data);
                }
            });
    }

    const updater = (appointmentStatus, dates) => getCustomerAppointments(appointmentStatus, dates);

    const appointmentRender = {
        WAITING: <Tag color='cyan'>BEKLIYOR</Tag>,
        POSITIVE: <Tag color='green'>OLUMLU</Tag>,
        NEGATIVE: <Tag color='red' >OLUMSUZ</Tag>
    };

    const createBrandFilter = () => {
        const brandFiltered = tableData.filter(i => i.b);
        return brandFiltered.length
            ? removeDuplicates(brandFiltered, 'b')
            : [];
    };

    const createEmployeeFilter = () => {
        const employeeFiltered = tableData.filter(i => i.e)
        return employeeFiltered.length
            ? removeDuplicates(employeeFiltered, 'e')
            : [];
    }

    const removeDuplicates = (arr, field) => {
        const uniqueNames = {};
        for (const obj of arr) {
            if (!uniqueNames[obj[field]]) {
            uniqueNames[obj[field]] = true;
            }
        }
        const uniqueObjects = [];
        for (const obj of arr) {
            if (uniqueNames[obj[field]]) {
            uniqueObjects.push({text: obj[field], value: obj[field]});
            delete uniqueNames[obj[field]];
            }
        }
        return uniqueObjects;
    }
    
    const columns = [
        {
            title: 'Durum',
            dataIndex: 's',
            key: 's',
            render: (t) => appointmentRender[t]
        },
        {
            title: 'Marka',
            dataIndex: 'b',
            key: 'b',
            filters: createBrandFilter(),
            onFilter: (value, record) => record.b === value

        },
        {
            title: 'Çalışan',
            dataIndex: 'e',
            key: 'e',
            filters: createEmployeeFilter(),
            onFilter: (value, record) => record.e === value
        },
        {
            title: 'İlgili',
            dataIndex: 'rp',
            key: 'rp'
        },
        {
            title: 'Aksiyon',
            key: 'appointmentDetail',
            render: (t, r) => <AppointmentDetails appointmentId={r.id}/>
        }
    ];

    const rowKeys = (record) => `${record.id}`;

    return(
        <React.Fragment>
            <Col span={9}>
              <Row align={'middle'} style={{marginBottom: '16px'}}>
                <CalendarTwoTone /><h4 style={{marginLeft: '6px', marginBottom: 0}}>Randevu Raporlama</h4>
              </Row>
              <AppointmentFilters updateSignal={updater}/>
              <Table rowKey={rowKeys} columns={columns} style={{marginTop: '16px'}} dataSource={tableData} size={'middle'}/>
            </Col>
            <Col span={14}>
                <AppointmentChart data={tableData}/>
            </Col>
        </React.Fragment>
    )
}

export default AppointmentList;